import NoFilter from "./no-filter";
import HeaderDate from "./date";
import Enum from "./enum";
import Text from "./text";

export const Header = { Date: HeaderDate, Enum, Text, NoFilter };
